import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { path: '', label: 'Dashboard', icon: '📊' },
  { path: 'goal', label: 'New Goal', icon: '➕' },
  { path: 'settings', label: 'Settings', icon: '⚙️' },
];

export default function BottomNav() {
  const location = useLocation();
  const basePath = location.pathname.split('/').slice(0, 3).join('/');

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-slate-800/90 backdrop-blur-lg border-t border-slate-700/50 safe-bottom z-50">
      <div className="max-w-lg mx-auto flex items-center justify-around h-16">
        {navItems.map((item) => {
          const isActive = location.pathname === basePath + (item.path ? `/${item.path}` : '');
          return (
            <Link
              key={item.path}
              to={basePath + (item.path ? `/${item.path}` : '')}
              className={`flex flex-col items-center justify-center w-full h-full space-y-0.5 transition-colors ${
                isActive ? 'text-primary-400' : 'text-slate-400 hover:text-slate-300'
              }`}
            >
              <span className="text-xl">{item.icon}</span>
              <span className="text-[10px] font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
